import { FEATURE_KEYS } from "./plans";
import { ACCESS_RULES } from "./access";

/**
 * MENU CONFIGURATION
 * 
 * Define a estrutura visual do menu lateral.
 * Cada item tem:
 * - label: texto exibido
 * - icon: ícone Phosphor (light weight)
 * - path: caminho da rota (sem tenant/branch prefix)
 * - feature: feature contratada necessaria para ver este item (opcional)
 * - permission: permissão necessária para ver este item (opcional)
 * - permissions: array de permissões (qualquer uma dá acesso)
 * - subItems: itens filhos (para menus expansíveis)
 * 
 * IMPORTANTE: Este arquivo NÃO importa componentes React.
 * O mapeamento path -> componente está em routeRegistry.js
 */

export const MENU_STRUCTURE = [
    { label: "Menu", isHeader: true },

    // ACESSO DIRETO
    {
        label: "Home",
        icon: "ph-light ph-house",
        path: "/home"
    },
    {
        label: "Dashboard",
        icon: "ph-light ph-squares-four",
        subItems: [
            { label: "Operacional", path: "/dashboard", feature: FEATURE_KEYS.DASHBOARD_OPERATIONAL },
            { label: "Gerencial", path: "/dashboard/gerencial", ...ACCESS_RULES.DASHBOARD_MANAGER },
            { label: "Financeiro", path: "/dashboard/financeiro", ...ACCESS_RULES.DASHBOARD_FINANCIAL },
        ]
    },
    {
        label: "Grade",
        icon: "ph-light ph-calendar-dots",
        path: "/grade",
        feature: FEATURE_KEYS.CLASS_MANAGEMENT,
        permission: "grade_manage"
    },
    {
        label: "Clientes",
        icon: "ph-light ph-users-three",
        path: "/members",
        feature: FEATURE_KEYS.MEMBERS_MODULE,
        permission: "members_manage"
    },

    // MÓDULOS AGRUPADOS 
    {
        label: "Administrativo",
        icon: "ph-light ph-briefcase",
        subItems: [
            { label: "Turmas", path: "/management/classes", feature: FEATURE_KEYS.CLASS_MANAGEMENT, permission: "admin_classes" },
            { label: "Colaboradores", path: "/admin/employees", ...ACCESS_RULES.TEAM_EMPLOYEES },
            { label: "Cargos", path: "/admin/roles", ...ACCESS_RULES.TEAM_ROLES },
            { label: "Planos", path: "/admin/memberships", ...ACCESS_RULES.MEMBER_MEMBERSHIPS },
            { label: "Produtos", path: "/admin/services", ...ACCESS_RULES.SALES_CATALOG },
            { label: "Áreas", path: "/admin/areas", permission: "admin_areas" },
            { label: "Alunos por Ativ.", path: "/management/activity-members", ...ACCESS_RULES.ACTIVITY_MEMBERS },
        ]
    },
    {
        label: "Gerencial",
        icon: "ph-light ph-chart-line-up",
        subItems: [
            { label: "CRM", path: "/crm", ...ACCESS_RULES.CRM },
            { label: "Experimentais", path: "/management/trials", ...ACCESS_RULES.TRIALS },
            { label: "Performance", path: "/management/performance", ...ACCESS_RULES.PERFORMANCE },
            { label: "Metas", path: "/management/goals", ...ACCESS_RULES.GOALS },
            { label: "Carteira de Alunos", path: "/admin/portfolio", ...ACCESS_RULES.PORTFOLIO },
            { label: "Cancelamentos", path: "/management/cancellations", ...ACCESS_RULES.CANCELLATIONS },
            { label: "Auditoria", path: "/admin/audit-logs", ...ACCESS_RULES.AUDIT_LOGS },
        ]
    },
    {
        label: "Técnico",
        icon: "ph-light ph-clipboard-text",
        subItems: [
            { label: "Atividades", path: "/admin/activities", permission: "admin_activities" },
            { label: "Níveis", path: "/admin/levels", permission: "management_evaluation_levels" },
            { label: "Treinos", path: "/training/workouts", ...ACCESS_RULES.TRAINING_WORKOUTS },
            { label: "Planejamento", path: "/grade/planning", ...ACCESS_RULES.PLANNING },
            { label: "Avaliações", path: "/evaluation", permission: "management_evaluation_run" },
            { label: "Eventos", path: "/admin/events", permission: "admin_events" },
        ]
    },
    {
        label: "Financeiro",
        icon: "ph-light ph-wallet",
        feature: FEATURE_KEYS.FINANCIAL_MODULE,
        subItems: [
            { label: "Caixa", path: "/financial/cashier", ...ACCESS_RULES.FINANCIAL_CASHIER },
            { label: "Contas a Receber", path: "/financial/receivables", ...ACCESS_RULES.FINANCIAL_REPORTS },
            { label: "Contas a Pagar", path: "/financial/payables", ...ACCESS_RULES.FINANCIAL_REPORTS },
            { label: "Fluxo de Caixa", path: "/financial/cash-flow", ...ACCESS_RULES.FINANCIAL_REPORTS },
            { label: "Vendas", path: "/financial/sales", ...ACCESS_RULES.FINANCIAL_REPORTS },
            { label: "Contas Bancárias", path: "/admin/bank-accounts", ...ACCESS_RULES.FINANCIAL_CONFIG },
            { label: "Adquirentes", path: "/admin/acquirers", ...ACCESS_RULES.FINANCIAL_ACQUIRERS },
            { label: "Categorias DRE", path: "/admin/financial-categories", ...ACCESS_RULES.FINANCIAL_CONFIG },
            { label: "DRE", path: "/financial/dre", ...ACCESS_RULES.FINANCIAL_REPORTS },
        ]
    },
    {
        label: "Configurações",
        icon: "ph-light ph-gear",
        subItems: [
            { label: "Dados da Empresa", path: "/settings/company", ...ACCESS_RULES.COMPANY_SETTINGS },
            { label: "Gamificação", path: "/settings/gamification", ...ACCESS_RULES.GAMIFICATION },
            { label: "Automações", path: "/settings/automations", ...ACCESS_RULES.AUTOMATIONS },
            { label: "Regras de Negócio", path: "/settings/business-rules", ...ACCESS_RULES.BUSINESS_RULES },
            { label: "Integrações", path: "/settings/integrations", ...ACCESS_RULES.INTEGRATIONS },
            { label: "Importação", path: "/settings/import-members", ...ACCESS_RULES.IMPORT_MEMBERS },
        ]
    },
    {
        label: "Totem",
        icon: "ph-light ph-monitor",
        subItems: [
            { label: "Tela", path: "/kiosk", feature: FEATURE_KEYS.KIOSK },
            { label: "Mídias", path: "/kiosk/media", feature: FEATURE_KEYS.MEDIA },
        ]
    }
]
